import React from 'react';
import './FiltersSelectionTable.css';

type FilterRow = {
  label: string;
};

const filterRows: FilterRow[] = [
  { label: 'Dates' },
  { label: 'Hours of week' },
  { label: 'Affiliate' },
  { label: 'Requested advertiser' },
  { label: 'Attributed advertiser' },
  { label: 'Requested Offers' },
  { label: 'Country' },
  { label: 'Smartlink' },
  { label: 'Carrier' },
  { label: 'Connection type' },
  { label: 'Platform' },
  { label: 'Attributed offers' },
];

export function FiltersSelectionTable() {
  return (
    <div className="filters-selection-wrap" role="presentation">
      <table className="filters-selection-table">
        <tbody>
          {filterRows.map((row) => (
            <tr key={row.label} className="filters-row">
              <td className="filters-cell-label">{row.label}</td>
              <td className="filters-cell-condition">
                <select className="filters-condition-select" defaultValue="in" aria-label={`Condición para ${row.label}`}>
                  <option value="in">In</option>
                  <option value="not-in">Not in</option>
                </select>
              </td>
              <td className="filters-cell-value">
                <input className="filters-value-input" placeholder="" aria-label={`Valores para ${row.label}`} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="filters-selection-footer">
        <button type="button" className="filters-selection-manage">
          Manage filters
        </button>
        <button type="button" className="filters-selection-clear">
          Clear all
        </button>
      </div>
    </div>
  );
}

